<template>
    <div>
      <!-- Sidebar en escritorio - nota el h-screen y inset-y-0 para que ocupe toda la altura -->
      <aside class="hidden md:flex md:w-64 bg-gray-900 text-white flex-col p-4 fixed inset-y-0 left-0">
        <div class="flex items-center space-x-3">
          <img 
          :src="user.avatar || '/images/icono-uda.png'" 
          :alt="user.avatar ? 'Foto de perfil' : 'Logo'" 
          class="h-10 w-10 rounded-full"
          @error="handleImageError"
          >
          <h1 class="text-lg font-bold">Portal Estudiantil</h1>
        </div>
        <p v-if="user" class="mt-4 text-sm">Bienvenido, {{ user.name }}</p>
        <nav class="mt-6 space-y-2">
          <!-- Inicio -->
          <RouterLink to="/inicio" class="flex items-center p-2 rounded hover:bg-gray-700">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-6 w-6 mr-2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 12l9-9 9 9M4 12v9h6v-6h4v6h6v-9" />
            </svg>
            Inicio
          </RouterLink>
  
          <!-- Perfil - Menú desplegable -->
          <div>
            <button @click="toggleSubmenu('Perfil')" class="flex items-center justify-between p-2 w-full rounded hover:bg-gray-700">
              <div class="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-6 w-6 mr-2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                </svg> 
                Perfil
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-4 w-4" :class="{'rotate-180': openSubmenus.Perfil}">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
              </svg>
            </button>
            <div v-if="openSubmenus.Perfil" class="pl-8 mt-1 space-y-1">
              <RouterLink to="/profile" class="block p-2 rounded hover:bg-gray-700">
                Datos Generales
              </RouterLink>
              <RouterLink to="/documentos" class="block p-2 rounded hover:bg-gray-700">
                Documentos
              </RouterLink>
              <RouterLink to="/incidencias" class="block p-2 rounded hover:bg-gray-700">
                Incidencias
              </RouterLink>
              <RouterLink to="/beneficios" class="block p-2 rounded hover:bg-gray-700">
                Beneficios
              </RouterLink>
            </div>
          </div>

          <!-- Académico - Menú desplegable -->
          <div>
            <button @click="toggleSubmenu('academico')" class="flex items-center justify-between p-2 w-full rounded hover:bg-gray-700">
              <div class="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-6 w-6 mr-2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
                </svg>
                Académico
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-4 w-4" :class="{'rotate-180': openSubmenus.academico}">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
              </svg>
            </button>
            <div v-if="openSubmenus.academico" class="pl-8 mt-1 space-y-1">
              <RouterLink to="/horario" class="block p-2 rounded hover:bg-gray-700">
                Horario
              </RouterLink>
              <RouterLink to="/calificaciones-boleta" class="block p-2 rounded hover:bg-gray-700">
                Boleta
              </RouterLink>
              <RouterLink to="/actividades" class="block p-2 rounded hover:bg-gray-700">
                Actividades
              </RouterLink>
              <RouterLink to="/inconformidades" class="block p-2 rounded hover:bg-gray-700">
                Inconformidades
              </RouterLink>
            </div>
          </div>
  
          <!-- Pagos - Menú desplegable -->
          <div>
            <button @click="toggleSubmenu('pagos')" class="flex items-center justify-between p-2 w-full rounded hover:bg-gray-700">
              <div class="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-6 w-6 mr-2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z" />
                </svg>
                Pagos
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-4 w-4" :class="{'rotate-180': openSubmenus.pagos}">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
              </svg>
            </button>
            <div v-if="openSubmenus.pagos" class="pl-8 mt-1 space-y-1">
              <!-- Colegiaturas submenu -->
              <div>
                <button @click="toggleSubmenu('colegiaturas')" class="flex items-center justify-between p-2 w-full rounded hover:bg-gray-700">
                  Colegiatura
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-4 w-4" :class="{'rotate-180': openSubmenus.colegiaturas}">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                  </svg>
                </button>
                <div v-if="openSubmenus.colegiaturas" class="pl-4 mt-1 space-y-1">
                  <RouterLink to="/calendario-colegiaturas" class="block p-2 rounded hover:bg-gray-700">
                    Calendario
                  </RouterLink>
                  <RouterLink to="/historial-colegiaturas" class="block p-2 rounded hover:bg-gray-700">
                    Historial
                  </RouterLink>
                </div>
              </div>
              
              <!-- Convenio submenu -->
              <div>
                <button @click="toggleSubmenu('convenio')" class="flex items-center justify-between p-2 w-full rounded hover:bg-gray-700">
                  Convenio
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-4 w-4" :class="{'rotate-180': openSubmenus.convenio}">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                  </svg>
                </button>
                <div v-if="openSubmenus.convenio" class="pl-4 mt-1 space-y-1">
                  <RouterLink to="/calendario-convenio" class="block p-2 rounded hover:bg-gray-700">
                    Calendario
                  </RouterLink>
                  <RouterLink to="/historial-convenio" class="block p-2 rounded hover:bg-gray-700">
                    Historial
                  </RouterLink>
                </div>
              </div>

              <!-- Datos fiscales y Facturar pagos -->
              <RouterLink to="/mis-datos-facturacion" class="block p-2 rounded hover:bg-gray-700">
                Datos fiscales
              </RouterLink>
              <RouterLink to="/facturar-pagos" class="block p-2 rounded hover:bg-gray-700">
                Facturar pagos
              </RouterLink>
            </div>
          </div>
  
          <!-- Prospectos - Menú desplegable -->
          <div>
            <button @click="toggleSubmenu('prospectos')" class="flex items-center justify-between p-2 w-full rounded hover:bg-gray-700">
              <div class="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-6 w-6 mr-2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6.75h5.25M18.375 4.5v4.5m-6.375-2.25a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM1.5 20.25a7.5 7.5 0 0115 0" />
                </svg> 
                Prospectos
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-4 w-4" :class="{'rotate-180': openSubmenus.prospectos}">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
              </svg>
            </button>
            <div v-if="openSubmenus.prospectos" class="pl-8 mt-1 space-y-1">
              <RouterLink to="/prospectos" class="block p-2 rounded hover:bg-gray-700">
                Registrar
              </RouterLink>
              <RouterLink to="/historial-prospectos" class="block p-2 rounded hover:bg-gray-700">
                Historial
              </RouterLink>
            </div>
          </div>

          <!-- Normatividad -->
          <RouterLink to="/normatividad" class="flex items-center p-2 rounded hover:bg-gray-700">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-6 w-6 mr-2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
            </svg>
            Normatividad
          </RouterLink>

          <!-- Cerrar sesión -->
          <button @click="logout" class="flex items-center p-2 rounded hover:bg-gray-700 w-full text-left">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-6 w-6 mr-2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
            </svg>
            Cerrar sesión
          </button>
        </nav>
      </aside>
  
      <!-- Mobile Sidebar -->
      <aside v-if="isMenuOpen" class="fixed inset-0 bg-gray-900 bg-opacity-80 z-20 md:hidden">
        <div class="fixed inset-y-0 right-0 w-full max-w-xs bg-gray-900 text-white p-4 z-30">
          <div class="flex justify-between items-center">
            <div class="flex items-center space-x-3">
              <img 
                :src="user.avatar || '/images/icono-uda.png'" 
                :alt="user.avatar ? 'Foto de perfil' : 'Logo'" 
                class="h-10 w-10 rounded-full"
                @error="handleImageError"
              >
              <h1 class="text-lg font-bold">Portal Estudiantil</h1>
            </div>
            <button @click="closeMenu" class="text-white text-lg">✖</button>
          </div>
          <p v-if="user" class="mt-4 text-sm">Bienvenido, {{ user.name }}</p>
          <nav class="mt-6 space-y-2">
            <!-- Inicio -->
            <RouterLink @click="closeMenu" to="/inicio" class="flex items-center p-2 rounded hover:bg-gray-700">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-6 w-6 mr-2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3 12l9-9 9 9M4 12v9h6v-6h4v6h6v-9" />
              </svg>
              Inicio
            </RouterLink>
  
            <!-- Perfil - Menú móvil -->
            <div>
              <button @click="toggleMobileSubmenu('Perfil')" class="flex items-center justify-between p-2 w-full rounded hover:bg-gray-700">
                <div class="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-6 w-6 mr-2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                  </svg> 
                  Perfil
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-4 w-4" :class="{'rotate-180': mobileOpenSubmenus.Perfil}">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </button>
              <div v-if="mobileOpenSubmenus.Perfil" class="pl-8 mt-1 space-y-1">
                <RouterLink @click="closeMenu" to="/profile" class="block p-2 rounded hover:bg-gray-700">
                  Datos Generales
                </RouterLink>
                <RouterLink @click="closeMenu" to="/documentos" class="block p-2 rounded hover:bg-gray-700">
                  Documentos
                </RouterLink>
                <RouterLink @click="closeMenu" to="/incidencias" class="block p-2 rounded hover:bg-gray-700">
                  Incidencias
                </RouterLink>
                <RouterLink @click="closeMenu" to="/beneficios" class="block p-2 rounded hover:bg-gray-700">
                  Beneficios
                </RouterLink>
              </div>
            </div>

            <!-- Académico - Menú móvil -->
            <div>
              <button @click="toggleMobileSubmenu('academico')" class="flex items-center justify-between p-2 w-full rounded hover:bg-gray-700">
                <div class="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-6 w-6 mr-2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
                  </svg>
                  Académico
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-4 w-4" :class="{'rotate-180': mobileOpenSubmenus.academico}">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </button>
              <div v-if="mobileOpenSubmenus.academico" class="pl-8 mt-1 space-y-1">
                <RouterLink @click="closeMenu" to="/horario" class="block p-2 rounded hover:bg-gray-700">
                  Horario
                </RouterLink>
                <RouterLink @click="closeMenu" to="/calificaciones-boleta" class="block p-2 rounded hover:bg-gray-700">
                  Boleta
                </RouterLink>
                <RouterLink @click="closeMenu" to="/actividades" class="block p-2 rounded hover:bg-gray-700">
                  Actividades
                </RouterLink>
                <RouterLink @click="closeMenu" to="/inconformidades" class="block p-2 rounded hover:bg-gray-700">
                  Inconformidades
                </RouterLink>
              </div>
            </div>
  
            <!-- Pagos - Menú móvil -->
            <div>
              <button @click="toggleMobileSubmenu('pagos')" class="flex items-center justify-between p-2 w-full rounded hover:bg-gray-700">
                <div class="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-6 w-6 mr-2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z" />
                  </svg>
                  Pagos
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-4 w-4" :class="{'rotate-180': mobileOpenSubmenus.pagos}">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </button>
              <div v-if="mobileOpenSubmenus.pagos" class="pl-8 mt-1 space-y-1">
                <!-- Colegiaturas submenu -->
                <div>
                  <button @click="toggleMobileSubmenu('colegiaturas')" class="flex items-center justify-between p-2 w-full rounded hover:bg-gray-700">
                    Colegiatura
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-4 w-4" :class="{'rotate-180': mobileOpenSubmenus.colegiaturas}">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                    </svg>
                  </button>
                  <div v-if="mobileOpenSubmenus.colegiaturas" class="pl-4 mt-1 space-y-1">
                    <RouterLink @click="closeMenu" to="/calendario-colegiaturas" class="block p-2 rounded hover:bg-gray-700">
                      Calendario
                    </RouterLink>
                    <RouterLink @click="closeMenu" to="/historial-colegiaturas" class="block p-2 rounded hover:bg-gray-700">
                      Historial
                    </RouterLink>
                  </div>
                </div>
                
                <!-- Convenio submenu -->
                <div>
                  <button @click="toggleMobileSubmenu('convenio')" class="flex items-center justify-between p-2 w-full rounded hover:bg-gray-700">
                    Convenio
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-4 w-4" :class="{'rotate-180': mobileOpenSubmenus.convenio}">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                    </svg>
                  </button>
                  <div v-if="mobileOpenSubmenus.convenio" class="pl-4 mt-1 space-y-1">
                    <RouterLink @click="closeMenu" to="/calendario-convenio" class="block p-2 rounded hover:bg-gray-700">
                      Calendario
                    </RouterLink>
                    <RouterLink @click="closeMenu" to="/historial-convenio" class="block p-2 rounded hover:bg-gray-700">
                      Historial
                    </RouterLink>
                  </div>
                </div>

                <!-- Datos fiscales y Facturar pagos -->
                <RouterLink @click="closeMenu" to="/mis-datos-facturacion" class="block p-2 rounded hover:bg-gray-700">
                  Datos fiscales
                </RouterLink>
                <RouterLink @click="closeMenu" to="/facturar-pagos" class="block p-2 rounded hover:bg-gray-700">
                  Facturar pagos
                </RouterLink>
              </div>
            </div>

            <!-- Prospectos - Menú móvil -->
            <div>
              <button @click="toggleMobileSubmenu('prospectos')" class="flex items-center justify-between p-2 w-full rounded hover:bg-gray-700">
                <div class="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-6 w-6 mr-2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6.75h5.25M18.375 4.5v4.5m-6.375-2.25a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM1.5 20.25a7.5 7.5 0 0115 0" />
                  </svg> 
                  Prospectos
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-4 w-4" :class="{'rotate-180': mobileOpenSubmenus.prospectos}">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              </button>
              <div v-if="mobileOpenSubmenus.prospectos" class="pl-8 mt-1 space-y-1">
                <RouterLink @click="closeMenu" to="/prospectos" class="block p-2 rounded hover:bg-gray-700">
                  Registrar
                </RouterLink>
                <RouterLink @click="closeMenu" to="/historial-prospectos" class="block p-2 rounded hover:bg-gray-700">
                  Historial
                </RouterLink>
              </div>
            </div>

            <!-- Normatividad -->
            <RouterLink @click="closeMenu" to="/normatividad" class="flex items-center p-2 rounded hover:bg-gray-700">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-6 w-6 mr-2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
              </svg>
              Normatividad
            </RouterLink>

            <!-- Cerrar sesión -->
            <button @click="logout" class="flex items-center p-2 w-full text-left rounded hover:bg-red-500">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-6 w-6 mr-2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
              </svg>
              Cerrar sesión
            </button>
          </nav>
        </div>
      </aside>
  
      <!-- Header móvil -->
      <header class="bg-white shadow-md p-4 flex justify-between items-center md:hidden">
        <img 
          :src="user.avatar || '/images/icono-uda.png'" 
          :alt="user.avatar ? 'Foto de perfil' : 'Logo'" 
          class="h-10 w-10 rounded-full"
          @error="handleImageError"
        >
        <div class="flex items-center space-x-4">
          <button @click="showNotifications" class="text-gray-600">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-6 w-6 mr-2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
            </svg>
          </button>
          <button @click="toggleMenu" class="flex items-center text-gray-600">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-1" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            <span class="text-sm font-medium">MENU</span>
          </button>
        </div>
      </header>
    </div>
  </template>
  
<script>
export default {
  name: 'SidebarMenu',
  props: {
    user: {
      type: Object,
      required: true
    },
    isMenuOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle-menu', 'close-menu', 'logout'],
  data() {
    return {
      openSubmenus: {
        Perfil: false,
        academico: false,
        pagos: false,
        colegiaturas: false,
        convenio: false,
        prospectos: false,
      },
      mobileOpenSubmenus: {
        Perfil: false,
        academico: false,
        pagos: false,
        colegiaturas: false,
        convenio: false,
        prospectos: false,
      }
    };
  },
  methods: {
    toggleMenu() {
      this.$emit('toggle-menu');
    },
    closeMenu() {
      this.$emit('close-menu');
      // Reset mobile submenus when closing main menu
      this.mobileOpenSubmenus = {
        Perfil: false,
        academico: false,
        pagos: false,
        colegiaturas: false,
        convenio: false,
        prospectos: false,
      };
    },
    closeAllSubmenus() {
      // Cierra todos los submenús
      Object.keys(this.openSubmenus).forEach(key => {
        this.openSubmenus[key] = false;
      });
    },
    closeAllMobileSubmenus() {
      // Cierra todos los submenús móviles
      Object.keys(this.mobileOpenSubmenus).forEach(key => {
        this.mobileOpenSubmenus[key] = false;
      });
    },
    toggleSubmenu(menu) {
      // Si el menú ya está abierto, lo cierra
      if (this.openSubmenus[menu]) {
        this.openSubmenus[menu] = false;
        return;
      }
      
      // Cierra todos los submenús antes de abrir el seleccionado
      this.closeAllSubmenus();
      
      // Para submenús dentro de pagos, asegúrate de que el menú de pagos esté abierto
      if ((menu === 'colegiaturas' || menu === 'convenio') && !this.openSubmenus.pagos) {
        this.openSubmenus.pagos = true;
      }
      
      // Abre el submenú específico
      this.openSubmenus[menu] = true;
    },
    toggleMobileSubmenu(menu) {
      // Si el menú ya está abierto, lo cierra
      if (this.mobileOpenSubmenus[menu]) {
        this.mobileOpenSubmenus[menu] = false;
        return;
      }
      
      // Cierra todos los submenús móviles antes de abrir el seleccionado
      this.closeAllMobileSubmenus();
      
      // Para submenús dentro de pagos, asegúrate de que el menú de pagos esté abierto
      if ((menu === 'colegiaturas' || menu === 'convenio') && !this.mobileOpenSubmenus.pagos) {
        this.mobileOpenSubmenus.pagos = true;
      }
      
      // Abre el submenú específico
      this.mobileOpenSubmenus[menu] = true;
    },
    // Método para manejar clics en elementos de menú no desplegables
    handleMenuClick() {
      // Cierra todos los submenús cuando se selecciona un elemento no desplegable
      this.closeAllSubmenus();
      this.closeAllMobileSubmenus();
    },
    showNotifications() {
      // Cierra submenús al mostrar notificaciones
      this.closeAllSubmenus();
      this.closeAllMobileSubmenus();
      console.log("Mostrar notificaciones");
    },
    async logout() {
      // Cierra submenús antes del logout
      this.closeAllSubmenus();
      this.closeAllMobileSubmenus();
      this.$emit('logout');
    },
    handleImageError(event) {
      event.target.src = '/images/icono-uda.png';
    }
  }
}
</script>